<template>
    <div>
        <PageBlock1 />
        <PageBlock2 />
        <PageBlock4 />
        <PageFooter />
        <!--
        <AboutUs />
        <PageBlock3 />
        -->
        
    </div>
  </template>
  
  <script>
import PageBlock1 from '../components/landingPage-block1.vue';
import PageBlock2 from '../components/landingPage-block2.vue';
//import PageBlock3 from '../components/landingPage-block3.vue';
import PageBlock4 from '../components/landingPage-block4.vue';
import PageFooter from '../components/landingPage-footer.vue';
//import AboutUs from '../components/landingPage-aboutUs.vue';

  export default {
    name: 'App',
    components: {
        PageBlock1,
        PageBlock2,
        //PageBlock3,
        PageBlock4,
        PageFooter,
        //AboutUs,
    }
  }
  </script>
  
  <style>
  </style>
  